(() => {
  const DESKTOP_MEDIA_QUERY = '(min-width: 1000px)';
  const stateStore = window.yesoulProductQuickAddCollapseState || new Map();

  window.yesoulProductQuickAddCollapseState = stateStore;

  class YesoulQuickAddCollapse extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.quickAdd = this.closest('product-quick-add');
      this.toggleButton = this.querySelector('button');
      this.controlledContent = this.quickAdd?.querySelector(this.getAttribute('controlled-selector'));
      this.desktopMedia = window.matchMedia(DESKTOP_MEDIA_QUERY);
      this.stateKey = this.getAttribute('state-key') || this.quickAdd?.getAttribute('form') || 'product-quick-add';

      if (!this.quickAdd || !this.toggleButton || !this.controlledContent) {
        return;
      }

      this.collapsed = stateStore.get(this.stateKey) === true;
      this.toggleButton.addEventListener('click', () => this.setCollapsed(!this.collapsed), {
        signal: this.abortController.signal
      });

      this.onMediaChange = () => this.renderState();
      this.desktopMedia.addEventListener('change', this.onMediaChange, {
        signal: this.abortController.signal
      });

      this.renderState();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    setCollapsed(collapsed) {
      this.collapsed = collapsed;
      stateStore.set(this.stateKey, collapsed);
      this.renderState();
    }

    renderState() {
      if (!this.quickAdd || !this.toggleButton || !this.controlledContent) {
        return;
      }

      const isDesktopCollapsed = this.desktopMedia.matches && this.collapsed;
      const collapseLabel = this.toggleButton.dataset.collapseLabel;
      const expandLabel = this.toggleButton.dataset.expandLabel;

      this.quickAdd.classList.toggle('is-collapsed', isDesktopCollapsed);
      this.toggleButton.setAttribute('aria-expanded', String(!isDesktopCollapsed));
      this.toggleButton.setAttribute('aria-label', isDesktopCollapsed ? expandLabel : collapseLabel);
      this.toggleButton.setAttribute('title', isDesktopCollapsed ? expandLabel : collapseLabel);
      this.controlledContent.toggleAttribute('inert', isDesktopCollapsed);

      if (isDesktopCollapsed) {
        this.controlledContent.setAttribute('aria-hidden', 'true');
      } else {
        this.controlledContent.removeAttribute('aria-hidden');
      }
    }
  }

  if (!customElements.get('yesoul-quick-add-collapse')) {
    customElements.define('yesoul-quick-add-collapse', YesoulQuickAddCollapse);
  }
})();
